import isPlainObject from 'lodash/isPlainObject';
import { call, select } from 'redux-saga/effects';

import { getPaymentOptions } from '../selectors';
import updatePaymentOptions from './api/updatePaymentOptions';

/**
 * If no options in payload, we just reload the paymentOptions with what's inside the store
 *
 * @param {Object} payload
 */
export default function* ({ value }) {
    const currentPaymentOptions = yield select(getPaymentOptions);

    const tradeIn = value ? parseFloat(value) : 0

    const paymentOptions = { ...currentPaymentOptions, tradeIn };

    yield call(updatePaymentOptions, paymentOptions);
}
